<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#20A8D8"
        :is-full-page="false"
      />

      <!-- Filter Options -->
      <b-row class="mt-2">
        <b-col sm="12" md="3" lg="3">
          <b-button
            v-b-popover.hover.right="'Toggle to show/hide filter options'"
            v-b-toggle.collapse-1
            class="filter"
          >
            FILTER OPTIONS
          </b-button>
        </b-col>
        <b-col sm="12">
          <b-collapse id="collapse-1" class="mt-2">
            <b-card>
              <b-row no-gutters class="mt-2">
                <b-col lg="3" md="6" sm="12" class="mr-4">
                  <b-form-group label="Date From">
                    <base-input type="date" name="dateFrom" :value="filterBy.dateFrom" />
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="6" sm="12" class="mr-4">
                  <b-form-group label="Date To">
                    <base-input type="date" name="dateTo" :value="filterBy.dateTo" />
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="6" sm="12" class="mr-4">
                  <b-form-group label="Status">
                    <b-form-select
                      v-model="filterBy.status"
                      :options="statusOptions"
                      class="mr-2"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col sm="12">
                  <b-button class="mr-1" variant="primary" @click="onFilterRequest">
                    Search
                  </b-button>
                  <b-button class="mr-1" variant="secondary" @click="resetFilters">
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <InquiriesTable :inquiries="inquiries" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
// Components
import InquiriesTable from "./Inquiries/InquiriesTable.vue";

// DAO
import inquiriesDAO from "@/database/inquiries.js";

// Util
import { DateUtil } from "@/util/dateUtil";

// Others
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  name: "inquiries",
  components: {
    InquiriesTable,
    Loading,
  },
  data() {
    return {
      inquiries: [],
      defaultFilterBy: {
        dateFrom: moment().format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        status: null,
      },
      filterBy: {
        dateFrom: moment().format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        status: null,
      },
      statusOptions: [
        {
          value: null,
          text: " - Please select - ",
        },
        {
          value: "PENDING",
          text: "PENDING",
        },
        {
          value: "CANCELLED",
          text: "CANCELLED",
        },
        {
          value: "DONE",
          text: "DONE",
        },
      ],

      isLoading: false,
    };
  },
  computed: {
    dateFrom() {
      const dateTo = moment();
      const dateFrom = dateTo.add(-30, "days");
      return dateFrom.format("YYYY-MM-DD");
    },
    dateTo() {
      return moment().format("YYYY-MM-DD");
    },
  },
  async mounted() {
    this.defaultFilterBy.dateFrom = this.dateFrom;
    this.defaultFilterBy.dateTo = this.dateTo;

    await this.resetFilters();
  },
  methods: {
    dateFromDisabled(_ymd, date) {
      return date > new Date();
    },
    async onFilterRequest() {
      if (!_.isEqual(this.filterBy, this.prevFilter)) {
        await this.retrieveData();
        this.prevFilter = { ...this.filterBy };
      }
    },
    async resetFilters() {
      if (!_.isEqual(this.filterBy, this.defaultFilterBy)) {
        // reset to default
        this.filterBy = { ...this.defaultFilterBy };
        this.prevFilter = { ...this.filterBy };

        await this.retrieveData();
      }
    },
    getFilterParam() {
      let filter = { ...this.filterBy };
      filter.fromTimestamp = DateUtil.startDateTimeStamp(new Date(filter.dateFrom));
      filter.toTimestamp = DateUtil.endDateTimeStamp(new Date(filter.dateTo));

      return filter;
    },
    async retrieveData() {
      try {
        // show loading indicator
        this.isLoading = true;

        let filter = this.getFilterParam();

        let inquiriesObj = await inquiriesDAO.getInquiries(filter);
        this.inquiries = Object.values(inquiriesObj);

        _.forEach(this.inquiries, (inquiry, id) => {
          let status = inquiry.status;
          if (status === "PENDING") {
            inquiry.statusType = "primary";
          } else if (status === "DONE") {
            inquiry.statusType = "success";
          } else if (status === "CANCELLED") {
            inquiry.statusType = "danger";
          }
        });
      } catch (error) {
        console.error("Error retrieving inquiries:", error);
        this.$toaster.error("Error loading data. Please reload the page again.");
      } finally {
        // hide loading indicator
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped></style>
